<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1"><a id="page_3"></a>Spanish Warships<br/><span class="fonts"><em class="italic">in the Age of Sail</em><br/>1700–1860</span></h1>
<p class="subtitle"><span class="bold">Design, Construction, Careers and Fates</span></p>
<p class="author"><span class="bold">R<span class="small-caps">IF</span> W<span class="small-caps">INFIELD</span> J<span class="small-caps">OHN</span> T<span class="small-caps">REDREA</span> E<span class="small-caps">NRIQUE</span> G<span class="small-caps">ARCÍA</span>-T<span class="small-caps">ORRALBA</span> P<span class="small-caps">ÉREZ</span> M<span class="small-caps">ANUEL</span> B<span class="small-caps">LASCO</span> F<span class="small-caps">ELIP</span></span></p>
<div class="image_containerf">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?13df2660